import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { FetchLoadRoute, logisticsActionCreators, LogisticsActionKeys } from '..';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { fetchLoadRoute } from '../logisticsApi';

function* fetchLoadRouteSaga(action: FetchLoadRoute) {
  yield put(uiActionCreators.toggleLoading('loadRoute'));

  const response = yield* call(fetchLoadRoute, action.payload.loadNumber);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(logisticsActionCreators.setRoute(response.value));
  }

  yield put(uiActionCreators.toggleLoading('loadRoute'));
}

export function* watchFetchLoadRoute() {
  yield takeEvery(LogisticsActionKeys.FETCH_LOAD_ROUTE, fetchLoadRouteSaga);
}
